// swiper front-page mv
const swiperMv = new Swiper(".top-mv__swiper", {
  loop: true,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  speed: 2000,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    1025: {
      slidesPerView: 1.1,
      spaceBetween: 25,
      centeredSlides: true,
    },
  },
});

const swiper = new Swiper(".c-slide-card .swiper", {
  speed: 1000,
  slidesPerView: 3.5, // 一度に表示する枚数
  spaceBetween: 32, // スライド間の距離
  mousewheel: true,
  // autoplay: {
  //     // 自動再生
  //     delay: 2000, // 1秒後に次のスライド
  //     disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  // },
  //ページネーション
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  // 前後の矢印
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    // disabledClass: "my-custom-disabled-class",
  },
});
